module.exports = __webpack_public_path__ + "media/images/user-logo2-322b3a7a1198c9d3e3367ccc287d8f86.png";